module.exports = "/lucky-balls/img/weager/Buy_Ticket.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Buy_Ticket.png
// module id = 1159
// module chunks = 0